import { SelReading_GetSelfReading } from 'data/endpoints';
import IDataService from 'data/IDataService';
import IRepository from 'data/IRepository';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import React, { useEffect, useState } from 'react';
import SelfReadingDTO from '../dtos/SelfReadingDTO';
import SelfReadingInfoCard from '../components/selfReading/SelfReadingInfoCard';
import { ContractType } from 'features/contracts/enums/contractType';
import EnergyUnit from 'features/contracts/components/EnergyUnit';

interface Props {
  selfReadingId: string;
  contractType: ContractType;
}

const SelfReadingDetailSection = ({ selfReadingId, contractType }: Props) => {
  // DI
  const dataService = useInjection<IDataService>(IocTypes.DataService);
  const selfReadingRepo = useInjection<IRepository<SelfReadingDTO>>(IocTypes.Repository);

  // helpers
  const getRouteParams = (): URLSearchParams => {
    let routeParams = new URLSearchParams();
    routeParams.set("selfReadingId", selfReadingId);
    
    return routeParams;
  }

  // state
  const [selfReading, setSelfReading] = useState<SelfReadingDTO>({});

  // side effects / fetch data
  useEffect(() => {
    // fetch self-reading
    dataService.fetchAndSetOne<SelfReadingDTO>(selfReadingRepo, setSelfReading, SelReading_GetSelfReading, getRouteParams(), undefined, true);
  }, [selfReadingId]);

  // render
  if (Object.keys(selfReading).length !== 0) {
    return (
      <>
        <SelfReadingInfoCard
          selfReading={selfReading}
          renderUnit={() => <EnergyUnit contractType={contractType} />}
        />
      </>
    )
  }  else {
    return null;
  }
}

export default SelfReadingDetailSection;
